import React, { useState } from 'react'
import { Col, Image, Modal, Row } from 'react-bootstrap'
import { brandImage1, brandImage2, enlargeIcon, logo, platinumImage } from '../../assets'

export default function Section8() {
    const [ShowImageEnlargeModal, setShowImageEnlargeModal] = useState(false)
    return (
        <Row className='section1 mx-0'>
            <Modal show={ShowImageEnlargeModal} onHide={() => setShowImageEnlargeModal(false)}>
                <Image src={platinumImage} width='100%' />
            </Modal>

            <Col lg={6} className='d-flex flex-column justify-content-center align-items-center'>
                <div style={{ cursor: 'pointer' }} onClick={() => setShowImageEnlargeModal(true)}>
                    <Image src={platinumImage} width='256px' height='205px' style={{boxShadow:'0px 25px 45px #000000'}}/>
                    <div className='d-flex align-items-center w-100 justify-content-center mb-3 mt-3'>
                        <Image src={enlargeIcon} width='21px' height='21px' />
                        <p className='mb-0' style={{ color: 'white', fontWeight: '700' }}>CLICK TO ENLARGE</p>
                    </div>
                </div>
                <Image src={brandImage1} className='brand-image2' />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center align-items-center'>
                <Image src={logo} width='382px' height='auto' />
                <p align='left' style={{ fontWeight: '700', marginTop: '32px' }}>This is made of 15 layers of veneer. Higher number of veneers make
                    it denser and stronger in every angle. Top grade resin is used to
                    make this product, to make it extreme boiling water proof quality
                    of up to 500+ hours.
                </p>
                <Row className='mx-0 w-100' style={{ fontWeight: '500', marginTop: '10px', marginBottom: '41px' }}>
                    <Col className='ps-0 col-auto'>
                        <ul>
                            <li style={{ textAlign: 'start' }}>Made from 15 layers</li>
                            <li style={{ textAlign: 'start' }}>Extreme boiling water proof quality</li>
                            <li style={{ textAlign: 'start' }}>High strength & stiffness</li>
                        </ul>
                    </Col>
                    <Col className='ps-0 ps-md-2 col-12 col-md-6'>
                        <ul>
                            <li style={{ textAlign: 'start' }}>100% selected timber</li>
                            <li style={{ textAlign: 'start' }}>Structurally balanced</li>
                            <li style={{ textAlign: 'start' }}>Borer proof</li>
                        </ul>
                    </Col>
                </Row>
                <Image src={brandImage2} className='brand-image2' />
            </Col>
        </Row >
    )
}
